// extracted by mini-css-extract-plugin
module.exports = {"logo":"Login_logo__1K2VD","france":"Login_france__3COKT"};